import { render, staticRenderFns } from "./ManageCommpanyBrandAdd.vue?vue&type=template&id=d52998e4&"
import script from "./ManageCommpanyBrandAdd.vue?vue&type=script&lang=js&"
export * from "./ManageCommpanyBrandAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports